import { GraphQLClient } from "graphql-request"
import { requestMiddleware } from "../utils/requestMiddleware"
import { initializeAccessRules } from "../utils/accessRules"

initializeAccessRules()

export const graphqlClient = new GraphQLClient(
  import.meta.env.SO_ADMIN_API_URL,
  { requestMiddleware: requestMiddleware.createGraphQLRequestMiddleware() },
)
